export interface AnomalyPrediction {
  is_anomaly: boolean;
  anomaly_score?: number | null;
  confidence?: number | null;
  per_detector?: Record<string, number> | null;
}

export interface ResultAnomalyProps {
  predictions: AnomalyPrediction[];
  thresholdUsed: number | null;
}

function fmt(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return v.toFixed(2);
}

export function ResultAnomaly({ predictions, thresholdUsed }: ResultAnomalyProps) {
  if (predictions.length === 0) {
    return <div className="text-xs text-fg-muted">No predictions returned.</div>;
  }
  const hasConfidence = predictions.some((p) => p.confidence != null);
  return (
    <div className="space-y-2">
      {thresholdUsed != null && (
        <div className="text-[11px] font-mono text-fg-muted">
          {`Threshold: ${thresholdUsed.toFixed(2)}`}
        </div>
      )}
      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-fg-muted border-b border-border">
            <th className="py-1.5 pr-3">#</th>
            <th className="py-1.5 pr-3">Anomaly</th>
            <th className="py-1.5 pr-3">Score</th>
            {hasConfidence && <th className="py-1.5">Confidence</th>}
          </tr>
        </thead>
        <tbody>
          {predictions.map((p, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: predictions have no stable ID
            <tr key={i} className="border-b border-border/60">
              <td className="py-1.5 pr-3 font-mono text-fg-dim">{i + 1}</td>
              <td className="py-1.5 pr-3">
                <span
                  className={`inline-block rounded px-1.5 py-0.5 font-mono text-[10px] ${
                    p.is_anomaly ? "bg-rose-100 text-rose-800" : "bg-zinc-100 text-zinc-700"
                  }`}
                >
                  {p.is_anomaly ? "yes" : "no"}
                </span>
              </td>
              <td className="py-1.5 pr-3 font-mono tnum">{fmt(p.anomaly_score)}</td>
              {hasConfidence && <td className="py-1.5 font-mono tnum">{fmt(p.confidence)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
